export const reviewsSelector = (reviewsObj) => {
  return Object.keys(reviewsObj)
    .map((reviewKey) => reviewsObj[reviewKey]);
};
